import React from 'react';
import PropTypes from 'prop-types';

import { getCrop } from '../../../utils/crops';
import { StyledImageLoaded } from './style';

const mimeByFormat = {
  webp: { mime: 'image/webp', extension: 'webp' },
  jpg: { mime: 'image/jpeg', extension: 'jpg' }
};

const EXTENSIONS = [
  'jpg',
  'JPG',
  'png',
  'PNG',
  'bmp',
  'BMP',
  'jpeg',
  'JPEG',
  'tiff',
  'TIFF'
];
export default class Image extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      isLoaded: false,
      extCounter: 0,
      src: null
    };
    this.onImageLoad = this.onImageLoad.bind(this);
    this.onImageError = this.onImageError.bind(this);
  }

  componentDidMount() {
    const { defaultCrop, path } = this.props;
    const { extCounter } = this.state;
    this.setState({
      src: getCrop({ path, crop: defaultCrop, format: EXTENSIONS[extCounter] })
    });
  }

  onImageLoad() {
    this.setState({ isError: false, isLoaded: true });
  }

  onImageError() {
    const { defaultCrop, path } = this.props;
    const { extCounter } = this.state;
    this.setState({
      isError: true,
      extCounter: extCounter + 1,
      src: getCrop({
        path,
        crop: defaultCrop,
        format: EXTENSIONS[extCounter + 1]
      })
    });
    if (EXTENSIONS.length !== extCounter) {
      this.setState({ isError: false });
    }
  }

  renderImage() {
    const {
      crops,
      className,
      defaultCrop,
      densities,
      formats,
      extFormat,
      lowCompression,
      path,
      placeholder: Placeholder,
      ...props
    } = this.props;
    const { src } = this.state;
    return (
      <span className="lazyImage">
        <img
          {...props}
          src={src}
          alt={props.alt}
          onLoad={this.onImageLoad}
          onError={this.onImageError}
        />
      </span>
    );
  }

  render() {
    const { crops, className, formats, path, home } = this.props;
    const { isError, isLoaded, src } = this.state;
    return (
      <figure className={className}>
        {!isError && src && (
          <StyledImageLoaded isLoaded={isLoaded} isError home={home}>
            {crops &&
              crops.length > 0 &&
              formats.reduce(
                (total, format) =>
                  total.concat(
                    crops.map(({ media, crop }) => (
                      <source
                        key={media + format}
                        type={mimeByFormat[format].mime}
                        media={media}
                        srcSet={getCrop({ path, crop, format })}
                      />
                    ))
                  ),
                []
              )}
            {this.renderImage()}
          </StyledImageLoaded>
        )}
      </figure>
    );
  }
}

const CropType = PropTypes.shape({
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired
});

Image.defaultProps = {
  placeholder: () => null,
  lowCompression: false,
  crops: [],
  formats: ['jpg'],
  densities: [1],
  path: undefined,
  defaultCrop: { width: 512, height: 288 },
  home: true
};

Image.propTypes = {
  className: PropTypes.string,
  path: PropTypes.string,
  placeholder: PropTypes.func,
  lowCompression: PropTypes.bool,
  defaultCrop: CropType,
  home: PropTypes.bool,
  crops: PropTypes.arrayOf(
    PropTypes.shape({
      media: PropTypes.string,
      crop: CropType.isRequired
    })
  ),
  densities: PropTypes.arrayOf(PropTypes.oneOf([1, 1.5, 2, 3, 4])),
  formats: PropTypes.arrayOf(PropTypes.oneOf(['webp', 'jpg']))
};
